export default "__VITE_ASSET__f35d1978__"